import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './initialState';
import { resetAllStores, resetPlanScopedStores } from '../sharedActions';
import {
  getAssinaturaPendente,
  getContratos,
  getLimite,
  getSolicitacao,
} from './thunks';

const loanSlice = createSlice({
  name: 'loan',
  initialState,
  reducers: {
    setSimulacao: (state, action) => {
      state.simulacao = action.payload;
    },
    desativaNotificacaoAssinatura: (state) => {
      state.assinaturaPendente.data.pendente = false;
    },
    resetLoan: (state) => {
      state.assinaturaPendente = initialState.assinaturaPendente;
      state.contratos = initialState.contratos;
      state.limite = initialState.limite;
      state.simulacao = initialState.simulacao;
      state.solicitacao = initialState.solicitacao;
    },
  },
  extraReducers(builder) {
    builder.addCase(resetAllStores, () => initialState);
    builder.addCase(resetPlanScopedStores, () => initialState);

    builder.addCase(getContratos.pending, (state) => {
      state.contratos.loading = true;
    });

    builder.addCase(getContratos.fulfilled, (state, { payload }) => {
      state.contratos = {
        listagemContratos: payload.listagemContratos,
        informacoesGerais: payload.informacoesGerais,
        loading: false,
        error: false,
      };
    });

    builder.addCase(getContratos.rejected, (state) => {
      state.contratos = {
        listagemContratos: initialState.contratos.listagemContratos,
        informacoesGerais: initialState.contratos.informacoesGerais,
        loading: false,
        error: true,
      };
    });

    builder.addCase(getLimite.pending, (state) => {
      state.limite.loading = true;
      state.limite.requestDone = false;
    });

    builder.addCase(getLimite.fulfilled, (state, { payload }) => {
      state.limite = {
        ...state.limite,
        ...payload,
        loading: false,
        error: false,
        requestDone: true,
      };
    });

    builder.addCase(getLimite.rejected, (state) => {
      state.limite = {
        ...initialState.limite,
        loading: false,
        error: true,
        requestDone: false,
      };
    });

    builder.addCase(getAssinaturaPendente.pending, (state) => {
      state.assinaturaPendente.loading = true;
    });

    builder.addCase(getAssinaturaPendente.fulfilled, (state, { payload }) => {
      state.assinaturaPendente = {
        ...payload,
        loading: false,
        error: false,
      };
    });

    builder.addCase(getAssinaturaPendente.rejected, (state) => {
      state.assinaturaPendente = {
        ...initialState.assinaturaPendente,
        loading: false,
        error: true,
      };
    });

    builder.addCase(getSolicitacao.pending, (state) => {
      state.solicitacao.loading = true;
    });

    builder.addCase(getSolicitacao.fulfilled, (state, { payload }) => {
      state.solicitacao = {
        ...state.solicitacao,
        ...payload,
        loading: false,
        error: false,
        requestDone: true,
      };
    });

    builder.addCase(getSolicitacao.rejected, (state) => {
      state.solicitacao = {
        ...initialState.solicitacao,
        loading: false,
        error: true,
        requestDone: false,
      };
    });
  },
});

export const loan = loanSlice.reducer;
export const { setSimulacao, desativaNotificacaoAssinatura, resetLoan } =
  loanSlice.actions;
